import React from 'react';
import { ArrowRightOutlineIcon } from '@domain-group/fe-co-icon';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { BodySection, LinkButton } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './banner.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Title = _ref => {
  var line1 = _ref.line1,
    line2 = _ref.line2,
    _ref$isDefault = _ref.isDefault,
    isDefault = _ref$isDefault === void 0 ? true : _ref$isDefault;
  return ___EmotionJSX("div", {
    css: styles.title(isDefault)
  }, ___EmotionJSX("div", null, line1), line2 && ___EmotionJSX("div", null, line2));
};
export var Banner = _ref2 => {
  var _ref2$appearance = _ref2.appearance,
    appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance,
    isMobile = _ref2.isMobile,
    line1 = _ref2.line1,
    line2 = _ref2.line2,
    description = _ref2.description,
    ctaLabel = _ref2.ctaLabel,
    ctaUrl = _ref2.ctaUrl,
    illustration = _ref2.illustration;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  var isDefault = appearance === 'default';
  return ___EmotionJSX(BodySection, {
    css: styles.bannerBodySection
  }, ___EmotionJSX("div", {
    css: styles.banner(isDefault)
  }, ___EmotionJSX("div", {
    css: styles.illustrationContainer(isDefault)
  }, illustration, isMobile && ___EmotionJSX(Title, {
    isDefault: isDefault,
    line1: line1,
    line2: line2
  })), ___EmotionJSX("div", {
    css: styles.infoContainer(isDefault)
  }, !isMobile && ___EmotionJSX(Title, {
    isDefault: isDefault,
    line1: line1,
    line2: line2
  }), ___EmotionJSX("div", {
    css: styles.bodyContainer
  }, ___EmotionJSX("div", {
    css: styles.description(isDefault)
  }, description), ___EmotionJSX(LinkButton, {
    appearance: isDefault ? 'primary' : 'ghost',
    href: getAbsoluteUrl === null || getAbsoluteUrl === void 0 ? void 0 : getAbsoluteUrl(ctaUrl),
    css: styles.cta(isDefault)
  }, ___EmotionJSX("div", {
    css: styles.ctaInner
  }, ctaLabel, ___EmotionJSX(ArrowRightOutlineIcon, null)))))));
};